<template lang="pug">
  theme-provider(:theme="theme")
    main.main.main__where-delivery
      header.main__header
        h1.main__title {{ $t('whereDelivery.title') }}
        h2.main__subtitle {{ $t('whereDelivery.subTitle') }}
      .main__container
        .main__content
          form.form.form_where-to-get(@submit.prevent="submitForm")
            .form__row
              .form__filed.form__field_row
                RadioButton(
                  value="np"
                  :label="$t('request.send.np.label')"
                  name="delivery"
                  :checked="delivery_type === 'newpost'"
                  v-on:changeRadio="delivery_type = 'newpost'"
                )
                RadioButton(
                  value="sho"
                  label="Забрать самостоятельно из магазина ШО"
                  name="delivery",
                  :checked="delivery_type === 'showroom'"
                  v-on:changeRadio="delivery_type = 'showroom'"
                )
            .form__row(v-if="delivery_type == 'showroom'")
              h2.form__text.form__title
                .form__text-row
                  .form__text-row_1
                    h3.form__text.form__text_bold {{ $t('request.send.sho.title') }}
                    address.form__text.form__text_gray.form__address {{ $t('request.send.sho.address') }}
            form.form.form_where-delivery(@submit.prevent="submitForm" v-else)
              .form__row
                .form__label(v-html="$t('whereDelivery.labels.city')")
                .form__field
                  v-select(:options="optionsCities" label="title" class="custom-select" :value="delivery.city" @input="setActiveCity" @search="citySearch" @open="cityOpen" @close="cityClose" :filterable="false")
                    template(slot="option" slot-scope="option" class="option") {{ option.title }}
                    template(slot="list-footer")
                      li(ref="cityLoad" class="loading" v-show="cityNextPage")
                    template(slot='no-options')
                      div(@mousedown.stop='')
                        | Извините, нет подходящих вариантов
                //span.form__error-text(v-if='$v.phrase.$error') {{ $t('whereDelivery.errors.city') }}
              .form__row
                label.form__label {{ $t('whereDelivery.labels.np') }}
                .form__field
                  v-select(:options="paginatedWarehouses" label="title" :value='delivery.warenhouse' @search="warehouseSearch" @open="warehouseOpen" @close="warehouseClose" @input="setActiveNp" class="custom-select" :filterable="false")
                    template(slot="option" slot-scope="option" class="custom-select__option") {{ option.title }}
                    template(slot="list-footer")
                      li(ref="warehouseLoad" class="loading")
                    template(slot='no-options')
                      div(@mousedown.stop='')
                        | Извините, нет подходящих вариантов
              .form__row.form__row-fio
                .form__label {{ $t('whereDelivery.labels.fio') }}
                input.form__input(type="text" v-model="delivery.receiver_name")
            footer.form__footer
              a.link-back(@click="$router.go(-1)") {{ $t('whereDelivery.buttons.back') }}
              input.button.form__submit(
                type="submit"
                :value="$t('changeWhereToGet.button')"
                :disabled="isDisabled"
              )
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { required, minLength } from 'vuelidate/lib/validators'
import { api } from '@/store/http-common'
import objectIsEmpty from '../mixins/objectIsEmpty'
import { mapGetters } from 'vuex'
import { theme } from '@/thems'
import { ThemeProvider } from 'vue-styled-components'
import { RadioButton } from '@/components/RadioButton'
const objectToFormData = require('object-to-formdata')
Vue.component('v-select', vSelect)

export default {
  name: 'Request_WhereDelivery',
  mixins: [ objectIsEmpty ],
  data () {
    return {
      optionsNp: [],
      optionsCities: [],
      cityNextPage: false,
      cityObserver: null,
      phrase: '',
      warehousePage: 1,
      warehousePhrase: '',
      warehouseObserver: null,
      debounce: null,
      infScrollLoading: false,
      theme: theme,
      delivery_type: '',
      delivery: {
        receiver_name: '',
        city: {
          code: '',
          title: ''
        },
        warenhouse: {
          code: '',
          title: ''
        }
      }
    }
  },
  validations: {
    delivery: {
      warenhouse: {
        title: {
          required,
          minLength: minLength(2)
        }
      },
      city: {
        title: {
          required,
          minLength: minLength(2)
        }
      },
      receiver_name: {
        required
      }
    },
    phrase: {
      required,
      minLength: minLength(3)
    },
    deliveryGroup: ['delivery.warenhouse', 'delivery.city', 'delivery.receiver_name']
  },
  created () {
    if (this.$isEmptyObject(this.product)) {
      this.fetchData()
    }
  },
  methods: {
    async fetchData () {
      await this.$store.dispatch('getTrackingData', this.trackingNumber)
      this.delivery_type = this.serviceInfo.delivery_type
      if (this.serviceInfo.delivery) {
        this.delivery = this.serviceInfo.delivery
      }
    },
    async citySearch (search) {
      if (search && search.length > 3) {
        clearTimeout(this.debounce)
        this.debounce = setTimeout(async () => {
          this.phrase = search
          let data = new FormData()
          data.append('phrase', this.phrase)
          const response = await api.post(`ajax.php?action=sg:service.api.address.findNpCity&page=1`, data)
          if (response.data.status === 'success') {
            this.optionsCities = response.data.data.CITIES
            this.cityNextPage = response.data.data.NEXT_PAGE
          } else {
            this.cityNextPage = false
            this.options = []
          }
        }, 600)
      }
    },
    async cityScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        console.log(this.phrase)
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        let data = new FormData()
        data.append('phrase', this.phrase)
        this.infScrollLoading = true
        const response = await api.post(`ajax.php?action=sg:service.api.address.findNpCity&page=${this.cityNextPage}`, data)
        if (response.data.status === 'success') {
          this.optionsCities = [...this.optionsCities, ...response.data.data.CITIES]
          this.cityNextPage = response.data.data.NEXT_PAGE
        } else {
          this.options = []
          this.cityNextPage = false
        }
        this.infScrollLoading = false
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async cityOpen () {
      console.log('open')
      await this.$nextTick()
      this.cityObserver.observe(this.$refs.cityLoad)
    },
    cityClose () {
      this.cityObserver.disconnect()
    },
    setActiveCity (city) {
      this.delivery.city = city
      this.$v.delivery.warenhouse.$touch()
      let data = new FormData()
      data.append('city', city.code)
      api
        .post('ajax.php?action=sg:service.api.address.getNpWarenhouses', data)
        .then(response => {
          this.optionsNp = response.data.data
          this.delivery.warenhouse = this.optionsNp[0]
          this.$v.delivery.warenhouse.$touch()
          this.warehousePage = 1
        })
    },
    warehouseSearch (value) {
      this.warehousePhrase = value
    },
    async warehouseInfScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.warehousePage = this.warehousePage + 1
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async warehouseOpen () {
      await this.$nextTick()
      this.warehouseObserver.observe(this.$refs.warehouseLoad)
    },
    warehouseClose () {
      this.warehouseObserver.disconnect()
    },
    setActiveNp (value) {
      if (value) {
        this.delivery.warenhouse = value
        this.$v.delivery.warenhouse.$touch()
      }
    },
    submitForm () {
      // Convert data to FormData
      let data = objectToFormData({
        delivery: this.delivery,
        delivery_type: this.delivery_type,
        code: this.trackingNumber
      })
      /**
       * Use api for change delivery address
       * @param {FormData} data
       * @return {object}
       */
      api
        .post('ajax.php?action=sg:service.api.repairrequest.changeDeliveryAddress', data)
        .then(response => {
          if (response.data.status === 'success') {
            this.$router.go(-1)
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      trackingNumber: 'getTrackingNumber',
      serviceInfo: 'getRequestAnswer'
    }),
    isDisabled () {
      return !(this.delivery_type === 'showroom' || !this.$v.deliveryGroup.$invalid)
    },
    filteredWarehouses () {
      return this.optionsNp.filter(item => item.title.includes(this.warehousePhrase))
    },
    paginatedWarehouses () {
      return this.filteredWarehouses.slice(0, this.warehousePage * 20)
    }
  },
  components: {
    ThemeProvider,
    RadioButton
  },
  mounted () {
    this.cityObserver = new IntersectionObserver(this.cityScroll)
    this.warehouseObserver = new IntersectionObserver(this.warehouseInfScroll)
  }
}
</script>

<style lang="scss">
.loading {
  height: 3px;
  margin-bottom: -4px;
  width: 100%;
  background: linear-gradient(#3c3c3c42, #3c3c3c42) left/0% 100% no-repeat;
  animation: anim 2s ease-in-out infinite alternate;
}
.custom-select {
  .vs__dropdown-menu {
    max-height: 243px;
  }
}
@keyframes anim {
  0% {
    background-size: 0% 100%;
    background-position: left;
  }
  50% {
    background-size: 70% 100%;
  }
  100% {
    background-size: 0% 100%;
    background-position: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Change_WhereDelivery.vue